import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    modal_container: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        margin: 0,
        padding: theme.spacing(2),
    },
    order_list_wrapper: {
        maxHeight: '250px',
        overflowY: 'auto',
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: theme.spacing(2),
        marginBottom: theme.spacing(2),
        padding: '5px',
    },
    order_item: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        border: '1px solid #ddd',
        borderRadius: 12,
        padding: theme.spacing(2),
        cursor: 'pointer',
        position: 'relative',
        backgroundColor: '#fff',
        transition: 'all 0.2s ease',
        '&:hover': {
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        },
    },
    selected: {
        border: `2px solid ${theme.palette.primary.main}`,
    },
    checkmark: {
        position: 'absolute',
        top: 8,
        right: 8,
        width: 20,
        height: 20,
        borderRadius: '50%',
        backgroundColor: theme.palette.primary.main,
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 12,
    },
    order_info: {
        marginBottom: theme.spacing(1),
    },
    order_number: {
        fontWeight: 600,
        fontSize: '1rem',
        marginBottom: 2,
    },
    service_name: {
        fontSize: '0.875rem',
        color: '#666',
    },
    order_meta: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginTop: theme.spacing(1),
    },
    total: {
        fontWeight: 600,
        fontSize: '1rem',
    },
    status: {
        fontSize: '0.75rem',
        fontWeight: 600,
        padding: '2px 8px',
        borderRadius: 12,
        textTransform: 'capitalize',
        backgroundColor: theme.palette.grey[200],
    },
    footer: {
        margin: '15px',
        display: 'flex',
        justifyContent: 'flex-end',
        borderTop: '1px solid #eee',
        paddingTop: theme.spacing(1),
        marginTop: theme.spacing(2),
    },
    pdf_container: {
        height: '100%',
    },
    itens_container: {
        height: '100%',
        width: '900px',
    },
    report_notice: {
        fontSize: 14,
        fontWeight: 500,
        color: '#333',
        backgroundColor: '#f9f9f9',
        padding: '10px 15px',
        borderBottom: '1px solid #ddd',
        borderRadius: '4px 4px 0 0',
        marginBottom: theme.spacing(2),
    }
}));

export { useStyles };
